import Empty from './empty';
import './empty.less';
export default Empty;